'use strict';

var propTypes = require('./prop-types.js');
var isHtmlElement = require('./is-html-element.js');
var isDefinedAndNotNull = require('./is-defined-and-not-null.js');
var requiredParameter = require('./required-parameter.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('./get-safe-html-element.js');
require('./can-use-dom.js');
require('exenv');
require('./is-defined.js');
require('./is-null.js');
require('./invalid-parameter-error.js');
require('@babel/runtime/helpers/classCallCheck');
require('@babel/runtime/helpers/inherits');
require('@babel/runtime/helpers/possibleConstructorReturn');
require('@babel/runtime/helpers/getPrototypeOf');
require('@babel/runtime/helpers/wrapNativeSuper');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Get the nearest scrollable element.
 *
 * @function
 * @param {HTMLElement} element - Element to take of reference.
 * @returns {HTMLElement} Returns the nearest scrollable element.
 * @example
 * getClosestScrollableElement();
 */

var getClosestScrollableElement = function getClosestScrollableElement() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requiredParameter('element');

  if (isDefinedAndNotNull(element) && isHtmlElement(element) && element !== document.documentElement) {
    var elementParent = element.parentElement;

    while (elementParent) {
      var _window$getComputedSt = window.getComputedStyle(elementParent),
          overflow = _window$getComputedSt.overflow;

      if (overflow.split(' ').every(function (eachOverflow) {
        return ['auto', 'scroll'].includes(eachOverflow);
      })) {
        return elementParent;
      }

      elementParent = elementParent.parentElement;
    }

    return document.documentElement;
  }

  return null;
};

getClosestScrollableElement.HELPER_ID = 'Gearz.JsUtils.getClosestScrollableElement';
getClosestScrollableElement.returnType = propTypes.instanceOfWithDescription(HTMLElement, 'Returns the nearest scrollable element.');
getClosestScrollableElement.parameterTypes = {
  element: propTypes.instanceOfWithDescription(HTMLElement, 'Reference element.').isRequired
};
getClosestScrollableElement.defaultParameters = {};

module.exports = getClosestScrollableElement;
